<template>
	<div class="advert-manage-container">
		<el-row :gutter="20">
			<el-col :span="16" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>销账金额(元)</span>
							<el-tooltip effect="dark" content="已核销的收款金额" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="line-chart actual top">
						<div class="stat-card" style="border: 1px solid rgb(225, 243, 216); background: rgb(225, 243, 216, 0.3)">
							<div class="stat-card__left">
								<div class="stat-card__label">本日</div>
								<div class="stat-card__sub">日结</div>
							</div>

							<div class="stat-card__value">210.00</div>

							<div class="stat-card__right">
								<div class="stat-card__trend stat-card__trend--up">
									环比
									<span class="value">↑ 12.5%</span>
								</div>
								<div class="stat-card__trend stat-card__trend--up">
									同比
									<span class="value">↑ 8.9%</span>
								</div>
							</div>
						</div>
						<div class="stat-card" style="border: 1px solid rgb(186, 224, 255); background: rgb(186, 224, 255, 0.3)">
							<div class="stat-card__left">
								<div class="stat-card__label">本日</div>
								<div class="stat-card__sub">日结</div>
							</div>

							<div class="stat-card__value">210.00</div>

							<div class="stat-card__right">
								<div class="stat-card__trend stat-card__trend--up">
									环比
									<span class="value">↑ 12.5%</span>
								</div>
								<div class="stat-card__trend stat-card__trend--up">
									同比
									<span class="value">↑ 8.9%</span>
								</div>
							</div>
						</div>
						<div class="stat-card" style="border: 1px solid rgb(255, 213, 145); background: rgb(255, 213, 145, 0.3)">
							<div class="stat-card__left">
								<div class="stat-card__label">本日</div>
								<div class="stat-card__sub">日结</div>
							</div>

							<div class="stat-card__value">210.00</div>

							<div class="stat-card__right">
								<div class="stat-card__trend stat-card__trend--up">
									环比
									<span class="value">↑ 12.5%</span>
								</div>
								<div class="stat-card__trend stat-card__trend--up">
									表现
									<span class="value">优秀</span>
								</div>
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>收款方式统计</span>
							<el-tooltip effect="dark" content="各收款方式的金额占比" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
						<el-date-picker
							v-model="dateRange"
							type="daterange"
							size="mini"
							range-separator="~"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							style="width: 220px"></el-date-picker>
					</div>
					<div class="line-chart top">
						<PieChart :categories="paymentMethodStats" title="总额" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="24" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">实收分析</div>
					<div class="line-chart actual">
						<div class="pie-chart">
							<PieChart :categories="collectionRate" title="累计清欠率" rate unit="万元" />
						</div>
						<div class="pie-chart">
							<PieChart :categories="monthChargingRate" title="本月收费率" rate unit="万元" />
						</div>
						<div class="pie-chart">
							<PieChart :categories="yearChargingRate" title="本年收费率" rate unit="万元" />
						</div>
					</div>
				</el-card>
			</el-col>

			<el-col :span="16" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>应实收统计(万元)</span>
							<el-tooltip effect="dark" content="应收与实收金额对比" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="line-chart">
						<LineTwoChart
							:xData="['1月', '2月', '3月']"
							:barData="[
								[120, 132, 101],
								[220, 182, 191],
							]" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>收费项目实收排名</span>
							<el-tooltip effect="dark" content="各收费项目实收金额排名" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
						<el-date-picker
							v-model="dateRange"
							type="daterange"
							size="mini"
							range-separator="~"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							style="width: 220px"></el-date-picker>
					</div>
					<div class="line-chart">
						<LeaseStatusStatistics />
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>欠费统计</span>
							<el-tooltip effect="dark" content="各项目欠费金额" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="line-chart">
						<LineChart :xData="arrearagexData" :barData="arrearagebarData" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>账龄分析</span>
							<el-tooltip effect="dark" content="欠费账龄分布" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="line-chart">
						<PieChart :categories="agingAnalysis" title="总计" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>押金余额统计(万元)</span>
							<el-tooltip effect="dark" content="各类押金余额" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="line-chart">
						<LineChart :xData="arrearagexData1" :barData="arrearagebarData1" color="#5AE88E" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>
							<span>预交余额统计(万元)</span>
							<el-tooltip effect="dark" content="各项目预交余额" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px; margin-left: 10px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="line-chart">
						<LineChart :xData="arrearagexData2" :barData="arrearagebarData" color="#FFB579" />
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import LineChart from '@/components/assets/lineChart.vue';
	import LineTwoChart from '@/components/assets/lineTwoChart.vue';
	import LeaseStatusStatistics from '@/components/assets/leaseStatusStatistics.vue';
	export default {
		name: 'FinanceAnalysis',
		components: { LineChart, LineTwoChart, LeaseStatusStatistics },
		data() {
			return {
				dateRange: [],
				paymentMethodStats: [
					{ name: '现金', value: 122 },
					{ name: '微信', value: 122 },
					{ name: '支付宝', value: 122 },
				],
				collectionRate: [
					{ name: '实收', value: 122 },
					{ name: '应收', value: 122 },
				],
				monthChargingRate: [
					{ name: '本月已收', value: 122 },
					{ name: '本月未收', value: 122 },
				],
				yearChargingRate: [
					{ name: '本年已收', value: 122 },
					{ name: '本年未收', value: 122 },
				],
				agingAnalysis: [
					{ name: '1个月以内', value: 122 },
					{ name: '1-3个月', value: 122 },
					{ name: '3-6个月', value: 122 },
					{ name: '6-12个月', value: 122 },
					{ name: '12个月以上', value: 122 },
				],
				arrearagexData: ['租金', '物业管理费', '租金2', '多种收费科目', '车位管理费'],
				arrearagexData1: [
					'未来科学城押金费用',
					'合同保证金',
					'装修施工保证金',
					'租赁意向金',
					'租赁意向金保证金',
					'水电周转金',
				],
				arrearagexData2: ['雅诗兰黛集团', '开元物业管理', 'SH-楼盘', '云上清华园商务广场', '海之星创园'],
				arrearagebarData: [280, 222, 100, 56, 70],
				arrearagebarData1: [280, 222, 100, 56, 70, 90],
			};
		},
		created() {},
		methods: {},
	};
</script>

<style scoped lang="scss">
	.advert-manage-container {
		padding: 20px;
		background-color: #f9fafc;
		text-align: left;
	}

	:deep(.el-card) {
		border-radius: 16px;
		.el-card__header {
			border-bottom: none;
			padding-bottom: 0;
		}
	}

	.rows {
		margin-top: 14px;
	}

	.header-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #0b1c30;
		font-weight: 600;
		font-size: 16px;
		height: 38px;
	}

	.line-chart {
		height: 300px;
	}

	.actual {
		display: flex;
		gap: 20px;
	}

	.top {
		height: 160px;
	}

	.pie-chart {
		flex: 1;
		border: 1px solid #e0e0e0;
		border-radius: 10px;
	}
	.stat-card {
		padding: 13px 24px;
		box-sizing: border-box;
		flex: 1;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}
	.stat-card__left,
	.stat-card__right {
		display: flex;
		justify-content: space-between;
	}

	.stat-card__value {
		font-weight: bold;
		font-size: 30px;
		padding-bottom: 12px;
		border-bottom: 1px solid #e0e0e0;
	}

	.value {
		color: #45ca76;
	}
</style>
